
export type MessagingConnectChatWebSocketParams = {
roomId: number;
};
